// Campspot booking strategy.
//
// URL shape:
//   ${site.reserveUrl}/site/${campsiteTypeId}/${arrival}/${checkout}/${guests}?location=${campsiteId}
//
// `guests` defaults to "guests0,2,0" and can be overridden via
// facility.extraAttributes.guests. `campsiteTypeId` and `campsiteId` come
// from site.extraAttributes. Manual held-site rows have no campsiteId, so
// they deliberately retain the category-level URL as an honest fallback.

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, facility, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    const guests = facility?.extraAttributes?.guests || "guests0,2,0";
    const categoryUrl = `${site.reserveUrl}/site/${site.extraAttributes.campsiteTypeId}/${format(arrivalDate, "yyyy-MM-dd")}/${format(checkout, "yyyy-MM-dd")}/${guests}`;
    const campsiteId = site.extraAttributes.campsiteId;
    return campsiteId ? `${categoryUrl}?location=${campsiteId}` : categoryUrl;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs({ facility } = {}) {
    const hasFacilityGuests = Boolean(facility?.extraAttributes?.guests);
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as the /<arrival>/ path segment (YYYY-MM-DD).",
        },
        departureDate: {
          status: "required",
          notes: "Encoded as the /<checkout>/ path segment (YYYY-MM-DD).",
        },
        ref: {
          status: "ignored",
          notes:
            "site.extraAttributes.campsiteTypeId builds the /site/<id>/ path and campsiteId preselects ?location= when known; ref is not encoded.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: hasFacilityGuests
            ? "Facility-level guests override is used; partySize is not encoded per-request."
            : "Campspot uses a facility-level guests default (guests0,2,0); partySize is not encoded per-request.",
        },
      },
    };
  },
};
